// import Calendar from "@/utils/calendar";

export const taglist = [
  { value: 1, label: "转正品" },
  { value: 2, label: "退货" },
  { value: 3, label: "新采购单入库" },
  { value: 10, label: "转公司库存" },
  { value: 11, label: "转用户库存" },
];
const warehouselist = ['待处理','已处理']
const servicelist =['未处理','已处理','处理中']

export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 50,
    fixed:'left',
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "批次号",
    dataIndex: "pkgCode",
    key: "pkgCode",
    width: 150,
    fixed:'left',
  },
  {
    title: "运单号",
    dataIndex: "expressNo",
    key: "expressNo",
  },
  {
    title: "位置",
    dataIndex: "gridCode",
    key: "gridCode",
  },
  {
    title: "处理结果",
    dataIndex: "tag",
    key: "tag",
      scopedSlots: {
        customRender: "tag",
      },
    // customRender: (text,record) => {
    //   return text?taglist.filter(v => v.value === text)?.[0].label:'-'
    // },
  },
  {
    title: "采购备注",
    dataIndex: "remark",
    key: "remark",
  },
    {
    title: "客户ID",
    dataIndex: "customerId",
    key: "customerId",
  },
  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
    ellipsis: true,
    width: 200
  },
  {
    title: "商品规格",
    dataIndex: "productProp",
    key: "productProp"
  },
  {
    title: "异常类型",
    dataIndex: "exceptionNames",
    key: "exceptionNames",
    width: 100,
    customRender: (text, record) => {
      let str = ''
      record.exceptionNames.forEach(item =>{
        str += (item + "；")
      })
      return str.slice(0,-1)
    },
  },
  {
    title: "异常件数",
    dataIndex: "amount",
    key: "amount",
    width: 100,
  },
  {
    title: "商品图片",
    dataIndex: "productImg",
    key: "productImg",
    width: 100,
    scopedSlots: {
      customRender: "productImg",
    },
  },
  {
    title: "异常图片",
    dataIndex: "imgs",
    key: "imgs",
    width: 100,
    scopedSlots: {
      customRender: "errorImg",
    },
  },
  {
    title: "业务处理状态",
    dataIndex: "serviceStatus",
    key: "serviceStatus",
    width: 120,
    customRender: (text,record) => {
        return servicelist[text]
    },
  },
  {
    title: "仓库处理状态",
    dataIndex: "wareStatus",
    key: "wareStatus",
    width: 120,
    customRender: (text,record) => {
        return warehouselist[text]
    },
  },
  {
    title: "异常来源",
    dataIndex: "exceptionSource",
    key: "exceptionSource",
    width: 100,
    customRender: (text,record) => {
        return {1:'简单检品',2:'详细检品'}[text]||'-'
    },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "创建人",
    dataIndex: "createrName",
    key: "createrName",
  },
  {
    title: "处理时间",
    dataIndex: "purchaseProcessTime",
    key: "purchaseProcessTime",
  },
  {
    title: "处理人",
    dataIndex: "purchaseOperatorName",
    key: "purchaseOperatorName",
    customRender: (text,record) => {
        return text||'-'
    },
  },
  // {
  //   title: "入库单",
  //   dataIndex: "inboundCode",
  //   key: "inboundCode",
  // },
  // {
  //   title: "处理结果",
  //   dataIndex: "tag",
  //   key: "tag",
  //   width:260,
  //   // customRender: (text, record, index) => {
  //   //   let desc = record.amount
  //   //   if(record.oemMoreInboundException){
  //   //     // desc = 'oemMoreInboundException'
  //   //     desc = record.processResults.map((item)=>{
  //   //       return `${item.amount}件${item.flowTagName}(${item.pkgCode})`
  //   //     },[])
  //   //   }else{
  //   //     desc = taglist.map(item =>{
  //   //       if(item.value == text){
  //   //         return item.label
  //   //       }
  //   //     })
  //   //   }
  //   //   return desc
  //   // },
  //   scopedSlots: {
  //     customRender: "tag",
  //   },
  // },
  // {
  //   title: "订单来源",
  //   width: 100,
  //   dataIndex: "systemSource",
  //   key: "systemSource",
  //   customRender: (text,record) => {
  //       return {1:'D2C',2:'B2B'}[text]||'-'
  //   },
  // },
  // {
  //   title: "提交人",
  //   dataIndex: "createrName",
  //   key: "createrName",
  //   customRender: (text,record) => {
  //       return text||'-'
  //   },
  // },
  // {
  //     title: '责任人',
  //     dataIndex: 'person',
  //     key: 'person'
  // },
  {
    title: "操作",
    dataIndex: "idAction",
    key: "idAction",
    width:170,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const dataSource = [
  {
    warehouse: "1",
    regionName: "1",
    regionContact: "1",
    contactPhone: "1",
    address: "1",
    total: "1",
    result: "1",
    num: "1",
    type: "1"
  },
];

export const logColumns = [
  {
    title: "场景",
    dataIndex: "operateNodeName",
    key: "operateNodeName",
  },
  {
    title: "内容",
    dataIndex: "context",
    key: "context",
  },
  {
    title: "操作人",
    dataIndex: "creatorName",
    key: "creatorName",
  },
  {
    title: "操作时间",
    dataIndex: "createTime",
    key: "createTime",
  },
]